export default __webpack_public_path__ + "static/media/phones.6a3568da.png";